var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showExternalUrl),expression:"showExternalUrl"}]},[_c('a',{staticClass:"external link",attrs:{"href":_vm.externalUrl,"target":"_blank","external":""}},[_vm._v("Read More")])])}
var staticRenderFns = []

export { render, staticRenderFns }